import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { setupCalendar } from 'v-calendar'
import router from './router'
import App from './App.vue'
import store from './store/index'
import i18n from './i18n'
import components from './components'
import sentryInit from './sentry'
import './styles/base.scss'
import './styles/mapbox.scss'
import './styles/mixins.scss'
import './styles/navvis.scss'
import './utils/extensions'

/**
 * Summary: Pinia is used for app state management
 */
const pinia = createPinia()

const app = createApp(App)
// array below controls which environments to track
if (
  ['production', 'development', 'experimental'].includes(
    process.env.VUE_APP_SENTRY_ENVIRONMENT ?? ''
  )
)
  sentryInit(app, router)
app.use(pinia)
app.use(store)
app.use(router)
app.use(i18n)
app.use(setupCalendar, {})
Object.entries(components).forEach(async ([name, component]) => {
  app.component(name, component)
})
app.mount('#app')
